@let skillRatingsValue = skillRatings();
@let statusValue = status();

<rt-box [variant]="'background-light no-padding'" layout-vertical margin-lr margin-bottom>
  @for (rating of skillRatingsValue; track rating.user.id; let last = $last) {
    <div class="skill-rating-container" padding-tb-small>
      <div layout layout-align-items-center min-width-0 padding-left padding-right-small-x>
        @if (rating.user) {
          <rt-avatar
            [type]="rating.user.hasAvatar ? 'image' : 'initials'"
            [size]="'small'"
            [shape]="'oval'"
            [imageSrc]="rating.user.photoThumbUrl"
            [initials]="rating.user.initials"
            margin-right-small-x
            margin-top-small-xx
          />
          <span
            [rtTooltip]="rating.user.name"
            [rtTooltipEnableWhenTruncated]="true"
            class="admin-name"
            text-darkest
            >{{ rating.user.name }}</span
          >
        }
      </div>

      <div layout-vertical min-width-0 padding-right>
        <rt-job-skill-scale-rating [rating]="rating" [status]="statusValue" />
      </div>
    </div>
    @if (!last) {
      <rt-divider />
    }
  }
</rt-box>
